/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    BlockShiftPuzzle = "block-shift-puzzle",
    NumberQuiz = "number-quiz",
    PatternPuzzle = "pattern-puzzle",
    TipQuiz = "tip-quiz",
};
